(() => {
  const root = document.getElementById('TpMobileMenu2027');
  if (!root || root.dataset.tpReady === 'true') return;

  root.dataset.tpReady = 'true';

  const trigger = document.querySelector('[data-mobile-menu]');
  const closeButton = root.querySelector('[data-tp-mm-close]');
  const overlay = document.querySelector('.background-overlay');
  const details = Array.from(root.querySelectorAll('[data-tp-mm-details]'));
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'summary',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  let wasOpen = false;
  let returnFocus = trigger || null;

  const isOpen = () => document.body.classList.contains('menu_open');

  const getFocusable = () =>
    Array.from(root.querySelectorAll(focusableSelector)).filter((element) => {
      if (element.offsetParent === null) return false;
      return !element.closest('[aria-hidden="true"]');
    });

  const syncState = () => {
    const open = isOpen();

    root.setAttribute('aria-hidden', open ? 'false' : 'true');

    if (trigger) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      trigger.setAttribute('aria-controls', 'TpMobileMenu2027');
    }

    if (open && !wasOpen) {
      returnFocus = document.activeElement === document.body ? trigger : document.activeElement;
      window.requestAnimationFrame(() => closeButton && closeButton.focus({ preventScroll: true }));
    }

    wasOpen = open;
  };

  const closeMenu = (restoreFocus = true) => {
    if (!isOpen()) return;

    document.body.classList.remove('menu_open');

    if (trigger) {
      trigger.classList.remove('active');
      trigger.setAttribute('aria-expanded', 'false');
    }

    root.setAttribute('aria-hidden', 'true');
    wasOpen = false;

    if (restoreFocus) {
      const target = returnFocus && document.contains(returnFocus) ? returnFocus : trigger;
      window.requestAnimationFrame(() => target && target.focus({ preventScroll: true }));
    }
  };

  if (trigger) {
    trigger.setAttribute('aria-controls', 'TpMobileMenu2027');
    trigger.setAttribute('aria-expanded', isOpen() ? 'true' : 'false');
    trigger.addEventListener('click', () => {
      returnFocus = trigger;
      window.requestAnimationFrame(syncState);
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', () => closeMenu(true));
  }

  if (overlay) {
    overlay.addEventListener('click', () => {
      if (isOpen() && root.getAttribute('aria-hidden') === 'false') closeMenu(true);
    });
  }

  details.forEach((item) => {
    item.addEventListener('toggle', () => {
      if (!item.open) return;
      details.forEach((other) => {
        if (other !== item) other.open = false;
      });
    });
  });

  root.addEventListener('keydown', (event) => {
    if (!isOpen()) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeMenu(true);
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = getFocusable();
    if (!focusable.length) {
      event.preventDefault();
      root.focus();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  root.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const current = new URL(window.location.href);
    const next = new URL(link.href, window.location.origin);

    if (current.pathname === next.pathname && current.search === next.search && next.hash) {
      closeMenu(false);
    }
  });

  const bodyObserver = new MutationObserver((mutations) => {
    if (!mutations.some((mutation) => mutation.attributeName === 'class')) return;
    syncState();
  });

  bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  syncState();
})();